import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ImageBackground,
    TextProps, ViewProps
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "./AppText";
import HideableView from "./HideableView";
import App from "../App";
import ISubClient from "../Models/Client/ISubClient";
import ConfirmionModal from "./ConfirmionModal";


type ProjectsScreenNavigationProp = StackNavigationProp< any, 'Projects'>;
interface IProps {
    client:ISubClient;
    removeCallBack:Function
}
interface IState {

}

export default class SubClientItem extends React.Component<IProps & ViewProps> {

    state:IState={

    }
    componentDidMount() {

    }

    render() {
        return(
            <View style={{maxHeight:45,width:'100%',flexDirection:'row',justifyContent:'center',backgroundColor:'#606060',paddingTop:5,paddingBottom:5,alignItems:'center',paddingLeft:15,paddingRight:15,borderBottomWidth:0.5,borderBottomColor:'white'}}>
                <View style={{flex:0.23,alignItems:'flex-start',justifyContent:'center',paddingTop:5}}>
                    <AppText style={{color:'#fff',fontSize:12,fontWeight:'700',lineHeight:14,textAlign:'left'}}>{this.props.client.name}</AppText>
                </View>
                <View style={{flex:0.34,alignItems:'flex-start',justifyContent:'center'}}>
                    <AppText style={{color:'#fff',fontSize:13,textAlign:'left'}}>{this.props.client.address}</AppText>
                </View>
                <View style={{flex:0.28,alignItems:'flex-start',justifyContent:'center',height:20}}>
                    <AppText style={{color:'#fff',fontSize:13,textAlign:'left'}}>{this.props.client.phone}</AppText>
                </View>
                <View style={{flex:0.15,alignItems:'center'}}>
                    <TouchableOpacity onPress={()=>this.props.removeCallBack(this.props.client)} style={{height:20,width:20,borderRadius:20,backgroundColor:'#019FB2',justifyContent:'center',alignItems:'center'}}>
                        <AppText style={{color:'white',fontSize:15,fontWeight:'500'}}>X</AppText>
                    </TouchableOpacity>
                </View>

            </View>
        );
    }
}

